module.exports = __webpack_public_path__ + "img/plan4_book01.a187986d.png";